/* tslint:disable */
// Re-export the module and configuration with expected names
export { ObjectObjectModule as ApiModule } from './object-object.module';
export { BASE_PATH } from './object-object.module';
export { ObjectObjectConfiguration, ObjectObjectConfigurationInterface } from './object-object-configuration';

// Re-export all services
export * from './services';

